<template>
    <Panel size="full" padding="p-4" :corners="false">
        <h2 class="text-base leading-6 font-black tracking-[0.25px] uppercase">
            {{ $t('statistics.winrate') }}
        </h2>
        <div class="mt-4 flex items-center gap-8">
            <DonutChart :percentage="winrate" :has-games="wins + losses > 0" class="size-[100px]">
                {{ winrate }}%
            </DonutChart>

            <dl class="flex min-w-0 flex-1 flex-col gap-4 text-sm leading-5 tracking-[0.25px]">
                <div class="border-stroke-1 flex items-center justify-between gap-2 border-b pb-4">
                    <dt class="flex items-center gap-2">
                        <span class="size-2 shrink-0 bg-green-600"></span>
                        {{ $t('statistics.wins') }}
                    </dt>
                    <dd
                        :class="
                            wins > 0 && wins >= losses ? 'font-black text-white' : 'text-titles'
                        "
                    >
                        {{ wins }}
                    </dd>
                </div>
                <div class="flex items-center justify-between gap-2">
                    <dt class="flex items-center gap-2">
                        <span class="size-2 shrink-0 bg-red-600"></span>
                        {{ $t('statistics.losses') }}
                    </dt>
                    <dd :class="losses > wins ? 'font-black text-white' : 'text-titles'">
                        {{ losses }}
                    </dd>
                </div>
            </dl>
        </div>
    </Panel>
</template>

<script>
import Panel from '@/components/layout/Panel.vue'
import DonutChart from '@/components/statistics/DonutChart.vue'

export default {
    name: 'WinrateCard',
    components: {
        Panel,
        DonutChart,
    },
    props: {
        wins: {
            type: Number,
            default: 0,
        },
        losses: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        winrate() {
            return this.wins + this.losses > 0
                ? Math.round((this.wins / (this.wins + this.losses)) * 100)
                : 0
        },
    },
}
</script>
